// extracted by mini-css-extract-plugin
module.exports = {"question":"TextArea_question_3Jmet","vCard":"TextArea_vCard_2PjR0","questions":"TextArea_questions_3FIAw","boxInput":"TextArea_boxInput_-1foi"};